import React from 'react';
import {SectionDetail, Tabs, Tab, TabPanel, Button, SmartTagText, Text} from 'components/core';
import {Grid} from '@material-ui/core';
import {ProceduresCtx, ProcedureFilesCtx, ProcedureFilesProvider} from 'components/dataProviders/procedures';
import {ProcedureStepsCtxProvider} from 'components/dataProviders/procedureSteps';
// import {Edit, Archive, Unarchive} from '@material-ui/icons';
import {Edit} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import FilesList from 'components/files/FilesList';
import EditWizard from './editWizard';
import Steps from './steps';
import {ItemDrawer} from 'components/procedures/items';
import {getHour} from 'controllers/Utils';

const styles = makeStyles((theme) => ({
  infoHeader: {
    fontSize: '13px',
    FontWeight: 400,
    color: theme.palette.text.primary,
    marginBottom: 3
  },
  infoRoot: {
    padding: 25
  },
  infoPair: {
    marginTop: 25
  },
  infoTitle: {
    fontSize: '18px',
    FontWeight: 800,
    color: theme.palette.text.secondary
  },
  infoField: {
    fontSize: '15px',
    FontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: "pre-line"
  },
  items: {
    marginTop: 25,
    '& > *': {
      margin: 5
    }
  }
}), {name: "RaymanProcedures"});

function secondsToMaskedTime(value)
{
    let min = Math.floor(value / 60);
    let hour = Math.floor(min / 60);
    min -= hour * 60;
    if(hour === 0)
    {
      if(min === 1) return "1 minuto";
      return min+" minutos";
    }
    else return hour.toString().padStart(2,"0")+"h "+min.toString().padStart(2,"0")+"m";
}


export default function ProceduresPanel({procedureID, onClose = () => {}, editable})
{
    const classes = styles();
    const [selectedTab, setSelectedTab] = React.useState(0);
    const procsCtx = React.useContext(ProceduresCtx);
    const [editDialogOpen, setEditDialogOpen] = React.useState(false);
    
    const handleClose = () => {
        onClose();
    }

    if(!procedureID) return null;

    const detailTabs = <Tabs value={selectedTab} onChange={(evt, index) => setSelectedTab(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Información"/>
        <Tab label="Pasos"/>
        <Tab label="Archivos"/>
    </Tabs>

    const procedure = procsCtx.data.indexed[procedureID];
    if(!procedure) return null;

    const header = <Grid container direction="row" spacing={2} justify="space-between">
      <Grid item><Grid container direction="row" spacing={1}>
        {editable && <Grid item><Button color="secondary" fullWidth={false} onClick={()=>setEditDialogOpen(true)}><Edit /> Editar</Button></Grid> }
        {!editable && <Grid item><Text title>{procedure.name}</Text></Grid> }
        {/* {!procedure.closed && <Grid item><Button color="error" fullWidth={false}><Archive /></Button></Grid> }
        {procedure.closed && <Grid item><Button color="secondary" fullWidth={false}><Unarchive /></Button></Grid> } */}
      </Grid></Grid>
    </Grid>

    
    return <SectionDetail onCloseClick={() => handleClose()} tabs={detailTabs} header={header} >
          <EditWizard open={editDialogOpen} handleClose={()=>setEditDialogOpen(false)} procedureID={procedureID} skipStepContext/>
          <TabPanel value={selectedTab} index={0}>
            <div className={classes.infoRoot}>
              <div className={classes.infoPair}>
                {/* <div className={classes.infoHeader}>Título</div> */}
                <div className={classes.infoTitle}>{procedure.name}</div>
              </div>
              <div className={classes.items}>{procedure.items.map((itemID) => <ItemDrawer itemID={itemID} key={itemID} />)}</div>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Descripción</div>
                <div className={classes.infoField}>{procedure.description}</div>
              </div><div className={classes.infoPair}>
                <div className={classes.infoHeader}>Duración estimada</div>
                <div className={classes.infoField}>{secondsToMaskedTime(procedure.executionTime)}</div>
              </div><div className={classes.infoPair}>
                <div className={classes.infoHeader}>Etiquetas</div>
                <div className={classes.infoField}><SmartTagText tagIDs={procedure.tags} /></div>
                {/* <div className={classes.infoHeader}>Items</div> */}
                
              </div>
            </div>
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <Steps procedureID={procedure.id}/>
          </TabPanel>
          <TabPanel value={selectedTab} index={2}>
            <FilesList context={ProcedureFilesCtx} />
          </TabPanel>
    </SectionDetail>
}